export default __webpack_public_path__ + "static/hp-brand-deck-27-37957bca0601caa1c48c9615017194ed.png";